/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { connect } from '@airglow/store-redux';
import ManageView from '../../ui/settings-view/manage.view.plugins';
import { manageViewPluginsMode } from '../data/prefabs';
import {
  selectModePluginsGrouped,
  selectAvailableModePluginsGrouped
} from '../selectors/manage.view.plugin.selectors';
import { updateViewPluginConfig, toggleUserUsesOrg } from '../actions';

const mapState = state => ({
  availableViewPlugins: selectAvailableModePluginsGrouped(state),
  mode: manageViewPluginsMode.value(state),
  viewPlugins: selectModePluginsGrouped(state)
});

const mapHandlers = dispatch => ({
  onMode: v => dispatch(manageViewPluginsMode.changeAction(v)),
  onToggleUserUsesOrg: v => dispatch(toggleUserUsesOrg(v)),
  onUpdatePluginConfig: v => dispatch(updateViewPluginConfig(v))
});

export default connect(mapState, mapHandlers)(ManageView);
